import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetFund() {
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/fund/-1',
    method: 'GET',
  }, { manual: true });
  const executeQuery = React.useCallback((id, features) => q({ url: `/api/v1/fund/${id}?features=${features}` }), [q]);
  return [state, executeQuery];
}
